import { Button, ClickEvent, DataSourceExecutionEvent, ScreenStack, Snackbar, TableSelectionEvent, Toast } from "@mcleod/components";
import { AutogenLayoutRecurringAvailableTractorList } from "./autogen/AutogenLayoutRecurringAvailableTractorList";
import { Api, UrlUtil } from "@mcleod/core";



export class RecurringAvailableTractorList extends AutogenLayoutRecurringAvailableTractorList {

    override onLoad() {
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search)
        if (urlProp != null && urlProp.ids != null) {
            this.tableRecurringAvailableTractor.setFilter(urlProp.ids);
        }
    }

    tableRecurringAvailableTractorOnSelect(event: TableSelectionEvent) {
        this.buttonCreateAvailableTractor.enabled = this.tableRecurringAvailableTractor.selectedRows.length > 0;
    }

    buttonCreateAvailableTractorOnClick(event: ClickEvent) {
        const button = event.target as Button;
        button.busy = true;
        const tractorIds = this.tableRecurringAvailableTractor.selectedRows.map(row => row.data.getNumber("id").toString());
        if (tractorIds.length > 0) {
            const progressSnackbar = Snackbar.showDownloadSnackbar(
                "Action In Progress",
                "Creating Available Tractors...",
                {persist: true, targetPanel: ScreenStack.getSnackbarTarget()}
            );
            return Api.post("lme/dispatch/create-tractor-from-recurring", {"tractor_ids": tractorIds})
            .then(result => Toast.showSuccessToast(`${result.data?.[0]?.created_count ?? 0} Available Tractor(s) Created Successfully`))
            .finally(() => {
                progressSnackbar.dismiss();
                button.busy = false;
            });
        } else {
            button.busy = false;
        }
    }
}